import { CustomLink, styled, ListContent } from '@teko/ds-desktop';
import { CheckOutlined } from '@teko/ds-icon';
import React, { useState, useEffect } from 'react';
import { getTrackingData } from '@teko/tracking';
import { TopbarButton } from './TopbarButton.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const TopbarDropdown = ({
  value,
  selectValue,
  options,
  href,
  tracking
}) => {
  const [show, setShow] = useState(false);
  const [activeOption, setActiveOption] = useState(options.find((option) => option.value === value));
  useEffect(() => {
    setActiveOption(options.find((option) => option.value === value));
  }, [value, options]);
  return /* @__PURE__ */ React.createElement(CustomLink, {
    href
  }, /* @__PURE__ */ React.createElement(Wrapper, {
    onMouseLeave: () => setShow(false)
  }, /* @__PURE__ */ React.createElement(TopbarButton, __spreadProps(__spreadValues({
    icon: activeOption == null ? void 0 : activeOption.icon
  }, tracking && getTrackingData(tracking)), {
    onMouseOver: () => setShow(true)
  }), activeOption == null ? void 0 : activeOption.text), /* @__PURE__ */ React.createElement(DropdownMenu, {
    show
  }, options.map((item, index) => /* @__PURE__ */ React.createElement(Option, {
    key: index
  }, /* @__PURE__ */ React.createElement(StyledListContent, {
    label: item.text,
    icon: item == null ? void 0 : item.icon,
    borderRadius: "s",
    onClick: () => selectValue(item.value)
  }), item.value === (activeOption == null ? void 0 : activeOption.value) && /* @__PURE__ */ React.createElement(CheckOutlined, {
    size: 24,
    color: "red",
    style: { position: "absolute", right: "8px" }
  }))))));
};
const Wrapper = styled.div`
  position: relative;
`;
const DropdownMenu = styled.div`
  display: ${(props) => props.show ? "block" : "none"};
  background-color: white;
  padding: 4px;
  border-radius: 4px;
  position: absolute;
  right: 20px;
  top: 35px;
  z-index: 10000;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  min-width: 11rem;
`;
const Option = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;
const StyledListContent = styled(ListContent)`
  cursor: pointer;
  width: 100%;
  padding: 8px 48px 8px 12px;
`;

export { TopbarDropdown };
